import { type AppState } from '~/store/app.store';
import { boundarySelectModalOpenSelector } from '~/store/frontendState/mapTools/boundary/boundarySelect/boundarySelect.selectors';
import { useSelector } from './useSelector';

const isToolWithCleanMapRequirementsActive = (state: AppState): boolean => {
  return !!boundarySelectModalOpenSelector(state);
};

/**
 * Returns `true` when an active map tool requires the map to be "clean" —
 * i.e. free of any other rendered entities (markers, routes, boundaries, etc.)
 * that would visually interfere with the tool's own map interactions.
 *
 * Use this hook in any component that renders content directly on the map.
 * When the hook returns `true`, suppress or hide that content so the active
 * tool has an unobstructed canvas to work with.
 *
 * @example
 * const requiresCleanMap = useRequiresCleanMap();
 * if (requiresCleanMap) return null;
  */
export const useRequiresCleanMap = () => {
  return useSelector(isToolWithCleanMapRequirementsActive);
};
